import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Svg18CopyG, Svg18CheckmarkG } from '@moim/icons';
import styled from 'styled-components';
import { useCallback, useState } from 'react';
import Clipboard from 'react-clipboard.js';

var InvisibleText = styled.span.withConfig({
  displayName: "InvisibleText",
  componentId: "sc-19ssv9v-0"
})(["position:fixed;top:0;left:-99999px;overflow:hidden;white-space:pre-line;"]);
var CopyIcon = styled(Svg18CopyG).attrs(function (props) {
  return {
    size: "xs",
    touch: 18,
    iconColor: "currentColor"
  };
}).withConfig({
  displayName: "CopyIcon",
  componentId: "sc-19ssv9v-1"
})([""]);
var CheckIcon = styled(Svg18CheckmarkG).attrs(function (props) {
  return {
    size: "xs",
    touch: 18,
    iconColor: "currentColor"
  };
}).withConfig({
  displayName: "CheckIcon",
  componentId: "sc-19ssv9v-2"
})([""]);
var ClipboardWrapper = function ClipboardWrapper(_ref) {
  var copyable = _ref.copyable,
    children = _ref.children,
    copyText = _ref.copyText;
  var getTarget = useCallback(function (e) {
    return e.nextElementSibling;
  }, []);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCopied = _useState2[0],
    setIsCopied = _useState2[1];
  if (!copyable) {
    return jsx(Fragment, {
      children: children
    });
  }
  return jsxs(Fragment, {
    children: [jsxs(Clipboard, {
      component: "span",
      style: {
        display: "inline-flex",
        alignItems: "baseline",
        gap: 8
      },
      options: {
        target: getTarget
      },
      onSuccess: function onSuccess() {
        setIsCopied(true);
        setTimeout(function () {
          setIsCopied(false);
        }, 3000);
      },
      children: [jsx(Fragment, {
        children: children
      }), !isCopied ? jsx(CopyIcon, {}) : jsx(CheckIcon, {})]
    }), jsx(InvisibleText, {
      children: copyText
    })]
  });
};

export { CheckIcon, ClipboardWrapper, CopyIcon, InvisibleText };
